/**
 * URL do avatar Discord (CDN). Funciona com hash ou fallback padrão.
 */
export function discordAvatarUrl(userId, avatarHash, size = 64) {
  const id = userId != null ? String(userId) : '';
  const hash = avatarHash != null && avatarHash !== '' ? String(avatarHash) : '';

  if (id && hash) {
    const ext = hash.startsWith('a_') ? 'gif' : 'png';
    return `https://cdn.discordapp.com/avatars/${id}/${hash}.${ext}?size=${size}`;
  }

  if (id) {
    // Fallback estável (sem BigInt/globalThis — eslint antigo no projeto)
    let sum = 0;
    for (let i = 0; i < id.length; i += 1) {
      sum = (sum + id.charCodeAt(i) * (i + 1)) % 6;
    }
    return `https://cdn.discordapp.com/embed/avatars/${sum}.png`;
  }

  return null;
}
